import { render } from "./DebugFlyoutAction.vue?vue&type=template&id=06dc3244&scoped=true"
const script = {}

import "./DebugFlyoutAction.vue?vue&type=style&index=0&id=06dc3244&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dc3244"]])

export default __exports__